import axios from 'axios';
import { API_URL, SERVER_URL } from '../../configs/env.config';

/**
 * Decrypt the request URL
 * @param request
 * @returns {Promise<*>}
 */
export const decryptRequestURL = async (request) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const response = await axios.get(`${SERVER_URL}/program/decrypt?request=${request}`, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Fetch API - [GET] get list automated broadcast
 * @param token
 * @returns {Promise<Array>}
 */
export const getAutomatedBroadcasts = async (token) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };
    const response = await axios.get(`${API_URL}/automated`, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * [PUT] Update automated broadcast
 * @param token
 * @param automated
 * @returns {Promise<*>}
 */
export const updateAutomatedBroadcast = async (token, automated) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };
    const data = JSON.stringify(automated);
    const response = await axios.put(`${API_URL}/automated`, data, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Fetch API - [GET] get list audiences
 * @param token
 * @returns {Promise<Array>}
 */
export const getAudiences = async (token) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };
    const response = await axios.get(`${API_URL}/segments`, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const fakeSync = () => new Promise((resolve) => {
  setTimeout(() => resolve(true), 1000);
});

/**
 * Send out sync - Onboarding
 */
export const sendOutSyncOnboarding = async (segmentID) => {
  try {
    // const options = {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${localStorage.getItem('token')}`
    //   }
    // };
    // await axios.put(`${API_URL}/segment/${segmentID}/sync`, options);
    // return true;
    await fakeSync();
    return true;
  } catch (err) {
    console.error(err && err.response);
    throw err;
  }
};



// WEBPACK FOOTER //
// ./src/containers/onboarder/api.js